










import Vue from "vue";

export default Vue.extend({
  name: "ButtonGroup",
  props: {
    center: {
      type: Boolean,
      required: false
    }
  }
});
